export class JobTitles {
    id: number = 0;
    name: string = '';
}
